/** @jsxImportSource @emotion/react */
import { SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { ThemeProp } from "../../../../styles/theme";

interface ButtonContainerProps {
  buttonType?: "primary" | "secondary";
  theme?: ThemeProp;
  shape?: "round" | "square";
  height?: number;
  widthExpand?: boolean;
  css?: SerializedStyles;
}

export const ButtonContainer = styled.button<ButtonContainerProps>`
  background-color: ${props =>
    props.buttonType === "secondary"
      ? props.theme.button.secondary.surface.default
      : props.theme.button.primary.surface.default};
  border: none;
  padding: 7px 18px;
  height: ${props => (props.height ? `${props.height}px` : "auto")};
  width: ${props => (props.widthExpand ? "100%" : "172px")};
  border-radius: ${props => (props.shape === "round" ? "21px" : "8px")};
  ${props => props.css};
  &:hover {
    background-color: ${props =>
      props.color === "secondary"
        ? props.theme.button.secondary.surface.hover
        : props.theme.button.primary.surface.hover};
  }
  transition: background-color 0.2s linear;
`;
